<template>
    <div>
        <div class="nav_tab">
            <ul>
                <li class="nav_list" v-if="navList && navList.length > 0" v-bind:class="{active:currentTab.prop == item.prop}" v-for="item in navList" v-on:click="changeTab(item)">
                    <p>{{item.name}}</p>
                </li>
            </ul>
        </div>
        <div class="content_panel">
            <div class="main_panel">
                <h3 class="panel_title">{{currentTab.name}}</h3>
                <div v-if="currentTab.prop == 'profit'">
                    <ul class="main_list">
                        <li class="list" style="min-width:150px;" v-for="(valueObject, key, index) in profitData" v-if="index == 1">
                            <ul>
                                <li class="li_height"></li>
                                <li class="li_height" v-for="(value, innerkey) in valueObject">{{mapList[innerkey]}}</li>
                            </ul>
                        </li>
                        <li class="list" v-for="(valueObject, key, index) in profitData">
                            <ul>
                                <li class="li_height">{{key}}</li>
                                <li class="li_height" v-for="(value, innerkey) in valueObject">{{value}}</li>
                            </ul>
                        </li>
                        
                    </ul>
                </div>
                <div v-if="currentTab.prop == 'cost'">
                  <div v-for="(item,index) in costData" class="cost_panel">
                    <div class="cost_frequency">
                      <span>{{item.name}}</span>
                    </div>
                    <div class="cost_chart">
                      <chart3 ref="chart5" v-if="hackReset && item.hackReset" v-bind:setId="'main'+index" v-bind:getData="item.data" v-bind:chartWidth="'10rem'" v-bind:chartHeight="'3rem'"></chart3>
                    </div>
                  </div>
                </div>
                <div v-if="currentTab.prop == 'targetDays'">
                    <chart2 ref="chart4" v-if="hackReset" v-bind:setId="'main3'" v-bind:getData="data4" v-bind:chartWidth="'12rem'" v-bind:chartHeight="'4rem'"></chart2>
                </div>
                <div v-if="currentTab.prop == 'isr'">
                    <chart2 ref="chart4" v-if="hackReset" v-bind:setId="'main4'" v-bind:getData="data4" v-bind:chartWidth="'12rem'" v-bind:chartHeight="'4rem'"></chart2>
                </div>
                <div v-if="currentTab.prop == 'serviceFrequency'">
                    <chart1 ref="chart1" v-if="hackReset" v-bind:setId="'main'" v-bind:yNanme="'平均值 Out Of Stock'" v-bind:getData="data1" v-bind:chartWidth="'14rem'" v-bind:chartHeight="'4rem'"></chart1>
                </div>
                <div v-if="currentTab.prop == 'serviceTotalCost'">
                    <chart1 ref="chart1" v-if="hackReset" v-bind:setId="'main1'" v-bind:yNanme="'成本'" v-bind:getData="data1" v-bind:chartWidth="'14rem'" v-bind:chartHeight="'4rem'"></chart1>
                </div>
                <div v-if="currentTab.prop == 'profitFrequency'">
                    <chart1 ref="chart1" v-if="hackReset" v-bind:setId="'main2'" v-bind:yNanme="'利润'" v-bind:getData="data1" v-bind:chartWidth="'14rem'" v-bind:chartHeight="'4rem'"></chart1>
                </div>
                <div v-if="currentTab.prop == 'kpi'">
                    <ul>
                        <li v-for="(valueInnerObject, keyOut) in kpiData">
                            <ul class="main_list">
                                <li style="position:relative;min-width:150px;" class="list title_list" v-if="indexInner == 1" v-for="(mainItem, keyInner,indexInner) in valueInnerObject">
                                    <span style="position: absolute;left: 10px;top: 52px;">{{keyOut}}</span>
                                    <ul>
                                        <li class="li_height"></li>
                                        <li class="li_height" v-for="(item, key) in mainItem">{{mapList[key]}}</li>
                                    </ul>
                                </li>
                                <li class="list" v-for="(mainItem, keyInner) in valueInnerObject">
                                    <ul>
                                        <li class="li_height">{{keyInner}}</li>
                                        <li class="li_height" v-for="(item, key) in mainItem">{{item}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="select_panel">
                <div>
                    <h3 class="line_red">POS ID Season</h3>
                    <div class="radio-box" v-for="(item,index) in posSeasonListAll" :key="item.id">
                        <span class="radio"></span>
                        <input v-model="posSeason" :value="item.id" class="input-radio" @click="checkSeason(item)" type="radio">{{item.posId}}{{item.season}}
                    </div>
                </div>
                <div v-if="currentTab.prop == 'profit'">
                    <h3 class="line_red">目标天数</h3>
                    <div class="radio-box" v-for="(item,index) in targetDaysAll" :key="item">
                        <span class="radio"></span>
                        <input v-model="modelDay" :value="item" class="input-radio" @click="checkDays(item)" type="radio">{{item}}
                    </div>
                </div>
                <div v-if="currentTab.prop == 'cost' || currentTab.prop == 'targetDays' || currentTab.prop == 'isr'">
                    <h3 class="line_red">补货频次</h3>
                    <div class="radio-box" v-for="(item,index) in frequenciesAll" :key="item">
                        <span class="radio"></span>
                        <input v-model="modelFrequency" :value="item" class="input-radio" @click="checkFrequency(item)" type="radio">{{item}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Chart1 from "@/components/common/chart1";
import Chart2 from "@/components/common/chart2";
import Chart3 from "@/components/common/chart3";
import {
  ResultProfit,
  ResultCost,
  ResultTargetDays,
  ResultIsr,
  ResultServiceFrequency,
  ResultServiceTotalCost,
  ResultProfitFrequency,
  Resultkpi,
  getSeasonStoreList
} from "../../util/api.js";
export default {
  name: "moreResult",
  data() {
    return {
      navList: [
        {
          name: "利润",
          prop: "profit",
          type: false
        },
        {
          name: "成本",
          prop: "cost",
          type: false
        },
        {
          name: "目标天数",
          prop: "targetDays",
          type: false
        },
        {
          name: "ISR",
          prop: "isr",
          type: false
        },
        {
          name: "服务角度（补货频次）",
          prop: "serviceFrequency",
          type: false
        },
        {
          name: "服务角度（总成本）",
          prop: "serviceTotalCost",
          type: false
        },
        {
          name: "利润角度（补货频次）",
          prop: "profitFrequency",
          type: false
        },
        {
          name: "KPI",
          prop: "kpi",
          type: false
        }
      ],
      storeList:[],
      userId: "",
      currentTab: "",
      profitData: "",
      kpiData: "",
      posSeasonList: [],
      posSeasonListAll:[],
      targetDays: [],
      targetDaysAll:[],
      posSeason: "",
      modelDay: "",
      currentDay: "",
      frequency: "",
      modelFrequency:"",
      frequencies: [],
      frequenciesAll: [],
      hackReset:false,
      data1: {
        list: [],
        hackReset: false
      },
      data4: {
        list: {
          income: [],
          profit: [],
          avg: []
        },
        days: [],
        hackReset: false
      },
      costData: [],
      mapList:{
        costHold:'平均值 Cost Hold',
        costOrderCount:'平均值 Cost Order Count',
        costSales:'平均值 Cost Sales',
        costTotal:'平均值 Cost Total',
        costTrans:'平均值 Cost Trans',
        estimateProfit:'平均值 利润',
        grossMargin:'平均值 Gross Margin',
        revenue:'平均值 收益',
        roi:'平均值 ROI',
        inventory: '平均值 Inventory',
        isr: '平均值 ISR',
        outOfStock: 'Out Of Stock 计数',
        st:'平均值 ST'
      }
    };
  },
  components: { Chart1, Chart2, Chart3 },
  methods: {
    changeTab: function(item) {
      this.hackReset = false;
      this.currentTab = item;
      this.data1.hackReset = false;
      switch (item.prop) {
        case "profit":
          this.getProfit();
          break;
        case "cost":
          this.getCost();
          break;
        case "targetDays":
          this.getTargetDays();
          break;
        case "isr":
          this.getIsr();
          break;
        case "serviceFrequency":
          this.getServiceFrequency();
          break;
        case "serviceTotalCost":
          this.getServiceTotalCost();
          break;
        case "profitFrequency":
          this.getProfitFrequency();
          break;
        case "kpi":
          this.getKpi();
      }
    },
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    checkSeason: function(item) {
      this.posId = item.posId == '全部'?'':item.posId;
      this.season = item.season;
      console.log(this.posId);
      this.changeTab(this.currentTab);
    },
    checkDays: function(item) {
      this.currentDay = item == '全部'?0:item;
      this.changeTab(this.currentTab);
      console.log(this.currentDay);
    },
    checkFrequency:function(item){
      this.frequency = item == '全部'?'':item;
      this.changeTab(this.currentTab);
    },
    init: function() {
      this.currentTab = this.navList[0];
      this.userId = this.getCookie("rstuserId");
      let that = this;
      Resultkpi({
        userId: this.userId,
        posId: this.posId,
        season: this.season
      }).then(function(res) {
        console.log(res);
        let data = res.data.result;
        that.targetDays = Object.keys(data);
        let oneDay = ['全部'];
        that.targetDaysAll = oneDay.concat(that.targetDays);
        that.currentDay = 0;
        that.modelDay = that.targetDaysAll[0];
        that.getProfit();
      });
    },
    getProfit: function() {
      let that = this;
      ResultProfit({
        userId: this.userId,
        posId: this.posId,
        season: this.season,
        targetDay: this.currentDay
      }).then(function(res) {
        that.profitData = res.data.result;
        that.frequencies = Object.keys(that.profitData);  //获取补货频次，可能不一致哦
        let oneArray = ['全部'];
        that.frequenciesAll = oneArray.concat(that.frequencies);
        that.frequency = '';
        that.modelFrequency = that.frequenciesAll[0];
        console.log(res);
      });
    },
    getCost: function() {
      let that = this;
      ResultCost({
        userId: this.userId,
        posId: this.posId,
        season: this.season,
        frequency: this.frequency
      }).then(function(res) {
        console.log(res);
        let data = res.data.result;
        let frequencyArray = Object.keys(data);
        let currentF = that.frequency?that.frequency:that.frequencies[0];
        let oneArray = Object.keys(
          data[currentF][that.targetDays[0]]
        );
        that.costData = [];
        frequencyArray.forEach((elementOut, i) => {
          that.targetDays.forEach(element => {
            if (!that.costData[i]) {
              that.costData[i] = {};
            }
            that.costData[i].name = elementOut;
            that.costData[i].hackReset = false;
            if (!that.costData[i].data) {
              that.costData[i].data = {};
            }
            that.costData[i].data.day = that.targetDays;
            oneArray.forEach(elementArray => {
              if (!that.costData[i].data.list) {
                that.costData[i].data.list = [];
              }
              let count = 0;
              for (var j = 0; j < that.costData[i].data.list.length; j++) {
                if (that.costData[i].data.list[j].name == elementArray) {
                  that.costData[i].data.list[j].data.push(
                    data[elementOut][element][elementArray]
                  );
                } else {
                  count++;
                }
              }

              let arrayData = [];
              if (count == that.costData[i].data.list.length) {
                arrayData.push(data[elementOut][element][elementArray]);
                that.costData[i].data.list.push({
                  name: elementArray,
                  data: arrayData
                });
              }
            });
          });
          that.costData[i].hackReset = true;
          that.hackReset = true;
        });
        console.log(that.costData);
      });
    },
    getTargetDays: function() {
      let that = this;
      that.data4.hackReset = false;
      that.data4.list["income"] = [];
      that.data4.list["profit"] = [];
      that.data4.list["avg"] = [];
      ResultTargetDays({
        userId: this.userId,
        posId: this.posId,
        season: this.season,
        frequency: this.frequency
      }).then(function(res) {
        console.log(res);
        that.hackReset = true;
        let data = res.data.result;
        that.targetDays.forEach(element => {
          that.data4.list["income"].push(data[element].estimateProfit);
          that.data4.list["profit"].push(data[element].revenue);
        });
        console.log(that.data4);
        that.data4.days = that.targetDays;
        that.data4.hackReset = true;
        console.log(that.data4);
      });
    },
    getIsr: function() {
      let that = this;
      that.data4.hackReset = false;
      that.data4.list["income"] = [];
      that.data4.list["profit"] = [];
      that.data4.list["avg"] = [];
      ResultIsr({
        userId: this.userId,
        posId: this.posId,
        season: this.season,
        frequency: this.frequency
      }).then(function(res) {
        console.log(res);
        that.hackReset = true;
        let data = res.data.result;
        that.targetDays.forEach(element => {
          that.data4.list["avg"].push(data[element]);
        });
        console.log(that.data4);
        that.data4.days = that.targetDays;
        that.data4.hackReset = true;
        console.log(that.data4);
      });
    },
    getServiceFrequency: function() {
      let that = this;
      ResultServiceFrequency({
        userId: this.userId,
        posId: this.posId,
        season: this.season
      }).then(function(res) {
        console.log(res);
        that.frequencies.forEach(elementF => {
          let ifClicked = true;
          that.targetDays.forEach((element, i) => {
            if (!that.data1.list[i]) {
              that.data1.list[i] = {};
            } else if (
              that.data1.list[i].data.length == that.frequencies.length
            ) {
              that.data1.list[i] = {};
            }

            if (!that.data1.list[i].data) {
              that.data1.list[i].data = [];
            }
            that.data1.list[i].name = element;
            that.data1.list[i].data.push(res.data.result[elementF][element]);
            that.data1.hackReset = true;
          });
        });
        that.data1.frequency = that.frequencies;
        that.data1.days = that.targetDays;
        that.hackReset = true;
      });
    },
    getServiceTotalCost: function() {
      let that = this;
      ResultServiceTotalCost({
        userId: this.userId,
        posId: this.posId,
        season: this.season
      }).then(function(res) {
        console.log(res);
        that.frequencies.forEach(elementF => {
          let ifClicked = true;
          that.targetDays.forEach((element, i) => {
            if (!that.data1.list[i]) {
              that.data1.list[i] = {};
            } else if (
              that.data1.list[i].data.length == that.frequencies.length
            ) {
              that.data1.list[i] = {};
            }

            if (!that.data1.list[i].data) {
              that.data1.list[i].data = [];
            }
            that.data1.list[i].name = element;
            that.data1.list[i].data.push(res.data.result[elementF][element]);
            that.data1.hackReset = true;
          });
        });
        that.data1.frequency = that.frequencies;
        that.data1.days = that.targetDays;
        that.hackReset = true;
      });
    },
    getProfitFrequency: function() {
      let that = this;
      ResultProfitFrequency({
        userId: this.userId,
        posId: this.posId,
        season: this.season
      }).then(function(res) {
        console.log(res);
        that.frequencies.forEach(elementF => {
          let ifClicked = true;
          that.targetDays.forEach((element, i) => {
            if (!that.data1.list[i]) {
              that.data1.list[i] = {};
            } else if (
              that.data1.list[i].data.length == that.frequencies.length
            ) {
              that.data1.list[i] = {};
            }

            if (!that.data1.list[i].data) {
              that.data1.list[i].data = [];
            }
            that.data1.list[i].name = element;
            that.data1.list[i].data.push(res.data.result[elementF][element]);
            that.data1.hackReset = true;
          });
        });
        that.data1.frequency = that.frequencies;
        that.data1.days = that.targetDays;
        that.hackReset = true;
      });
    },
    getKpi: function() {
      let that = this;
      Resultkpi({
        userId: this.userId,
        posId: this.posId,
        season: this.season
      }).then(function(res) {
        console.log(res);
        that.kpiData = res.data.result;
      });
    }
  },
  mounted: function() {
    let that = this;
    getSeasonStoreList({ userId: that.getCookie("rstuserId") }).then(
      function(res) {
        if (res.data.success == true) {
          let data = Object.keys(res.data.result);
           that.posSeasonListAll.push(
            {
              season: '',
              store: '',
              posId: '全部',
              id:0
            }
          );
          data.forEach((element,i) => {
            that.posSeasonList.push({
              season: res.data.result[element].season,
              store: res.data.result[element].storeName,
              posId: res.data.result[element].posId
            });
            that.posSeasonListAll.push({
              season: res.data.result[element].season,
              store: res.data.result[element].storeName,
              posId: res.data.result[element].posId,
              id:i+1
            });
          });
          that.posSeason = 0;
          that.hackReset = true;
          that.init();
        }
      }
    );
  }
};
</script>
<style scoped>
ul {
  list-style: none;
}
.nav_tab ul {
  flex-direction: row;
  display: flex;
  width: 100%;
  list-style: none;
  height: 0.5rem;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.nav_list {
  flex: 1;
  border-right: 2px dashed #f0f0f1;
  cursor: pointer;
}
.nav_list.active {
  color: #fa5805;
  font-size: 0.2rem;
}
.content_panel {
  background-color: #fff;
  overflow: hidden;
  padding-top: 30px;
}
.main_panel {
  width: 80%;
  float: left;
}
.select_panel {
  padding-left: 50px;
  text-align: left;
  width: 20%;
  float: left;
}
.select_panel h3{
  font-size: 0.2rem;
  padding-top: 20px;
  padding-bottom: 5px;
}
.panel_title {
  height: 50px;
}
.main_list {
  display: flex;
}
.list {
  flex: 1;
  border: 1px solid #f6f6f6;
}
.li_height {
  height: 0.5rem;
  line-height: 0.5rem;
}
.li_height:nth-child(n) {
  background-color: #fff;
}
.li_height:nth-child(2n) {
  background-color: #f5f5f5;
}
.title_list .li_height {
  background-color: #fff;
  border-bottom: 1px solid #f6f6f6;
}
.cost_panel {
  overflow: hidden;
  border-bottom: 1px solid #333;
}
.cost_frequency {
  float: left;
  width: 2rem;
}
.cost_chart {
  float: left;
  border-left: 1px solid #333;
}
.radio-box{
  padding-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/page/moreResult.vue